import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    'API-Key': '318E31FA-2D4F-48B7-AB25-38142964881D'
  }
})
